<template>
  <div class="bq-solutions-zhyy">
    <div class="bq-solutions-banner">
      <div
        class="bq-banner-cover"
        :style="{ backgroundImage: `url(${cover})` }"
      >
        <div class="bq-solutions-title-wrap" :class="animateTitle">
          <div
            class="bq-solutions-title"
            :style="{ backgroundImage: `url(${titlebg})` }"
          ></div>
          <!-- <div class="bq-solutions-subtitle tl">
            实现医疗信息技术的最大限度应用，打造一个全面的数字化医院
          </div> -->
          <div class="bq-solutions-subtitle tl lt10">
            标准化数据中心/智慧服务/智慧临床/智慧管理
          </div>
        </div>
      </div>
    </div>
    <BqTab :tabs="tabs" :activeIndex="activeIndex" @handleClick="handleClick">
      <!-- 数据标化 -->
      <div class="bq-solution-item card" :slot="tabs[0].slot">
        <SectionTitle :title="tabs[0].title"></SectionTitle>
        <p class="tl">
          通过标准化健康医疗数据中心建设，有效提高数据质量，解耦各系统间复杂对接，形成数据标准，疏通各业务系统间的数据流通渠道，形成高效、有序
          的信息互通，解决医疗信息化在数据层面的核心问题。通过数据分析，挖掘数据价值，提供数据决策，让数据成为真正的生产力。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1eL6EC7T2gK0jSZPcXXcKkpXa-980-506.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1F8HzC7L0gK0jSZFtXXXQCXXa-980-242.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <!-- 智慧服务 -->
      <div class="bq-solution-item plat" :slot="tabs[1].slot">
        <SectionTitle :title="tabs[1].title"></SectionTitle>
        <div class="bq-solution-tag">让数据多跑步，让患者少走路</div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1nT2DCVT7gK0jSZFpXXaTkpXa-982-388.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'产品简介'"></SectionTitle>
        <p class="tl">
          以“互联网+”为手段，搭建医院智慧服务平台，围绕患者医疗服务需求，帮助医院建设健康门户、统一支付平台、互联网医院、健康管理等创新应用。
          覆盖患者诊前、诊中、诊后的线上/线下诊疗全流程，提高医院智慧服务水平，提升患者就诊体验。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1qCLFC.T1gK0jSZFrXXcNCXXa-318-424.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            class="mr15 ml15"
            src="https://img.alicdn.com/tfs/TB1l.zEC4D1gK0jSZFsXXbldVXa-317-424.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            src="https://img.alicdn.com/tfs/TB1bfHEC.z1gK0jSZLeXXb9kVXa-318-424.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'互联网医院'"></SectionTitle>
        <p class="tl">
          足不出户，在家即可实现看病就医全流程
        </p>
        <div class="w1200 tl">
          <img
            class="mr80"
            src="https://img.alicdn.com/tfs/TB176fFCWL7gK0jSZFBXXXZZpXa-244-244.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            src="https://img.alicdn.com/tfs/TB1Ab_KC.Y1gK0jSZFMXXaWcVXa-776-260.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div class="bq-imgbox-wrap">
          <div
            class="bq-imgtext-box"
            :style="{
              width: '333px',
              height: '694px',
              backgroundImage: `url('https://img.alicdn.com/tfs/TB1LL2GC7L0gK0jSZFtXXXQCXXa-333-694.png')`,
            }"
          >
            <span class="bq-img-text">
              患者通过移动端向线上医生发起在线问诊，包括图文、语音等形式。同时
              支持发起居家护理申请。
            </span>
          </div>
          <div
            class="bq-imgtext-box mr35 ml35"
            :style="{
              width: '463px',
              height: '694px',
              backgroundImage: `url('https://img.alicdn.com/tfs/TB1ZCHKCYH1gK0jSZFwXXc7aXXa-463-694.png')`,
            }"
          >
            <span class="bq-img-text">
              医生通过钉钉端与患者进行图文/语音交流，并支持线下诊断及开具处方；医师通过钉钉对开具的线上处方进行审核。
            </span>
          </div>
          <div
            class="bq-imgtext-box"
            :style="{
              width: '335px',
              height: '694px',
              backgroundSize: 'cover',
              backgroundImage: `url(
                'https://img.alicdn.com/tfs/TB1Me3nF1H2gK0jSZFEXXcqMpXa-581-1207.png'
              )`,
            }"
          >
            <span class="bq-img-text">
              护士通过钉钉对患者的居家护理申请进行接单，并在约定时间提供线下护理服务。
            </span>
          </div>
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1jubLCYY1gK0jSZTEXXXDQVXa-1202-68.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'健康门户'"></SectionTitle>
        <p class="tl">
          为用户提供统一的全流程智慧服务入口
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1ntgpC7L0gK0jSZFtXXXQCXXa-482-481.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'统一支付平台'"></SectionTitle>
        <p class="tl">
          搭建医院统一支付对账平台，提供聚合支付、医后付、财务对账等能力
        </p>
        <div class="bq-item-title">对账中心</div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1TBZpC8v0gK0jSZKbXXbK2FXa-782-284.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'信用付、医后付平台'"></SectionTitle>
        <p class="tl">
          基于蚂蚁金服花呗及芝麻信用体系，为用户提供无感信用支付方案。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1LQgrC.T1gK0jSZFhXXaAtVXa-783-278.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'刷脸就医'"></SectionTitle>
        <p class="tl">
          无需携带任何证件与手机，即可完成全流程实名制刷脸就医
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1LTotC.Y1gK0jSZFCXXcwqXXa-1017-255.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'健康管理平台'"></SectionTitle>
        <p class="tl">
          基于医疗大数据平台以及健康算法模型，为患者提供全生命周期的精准健康管理服务
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1.HwuCYY1gK0jSZTEXXXDQVXa-1052-405.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1sNctC4v1gK0jSZFFXXb0sXXa-1056-58.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
      <!-- 智慧临床 -->
      <div class="bq-solution-item" :slot="tabs[2].slot">
        <SectionTitle :title="tabs[2].title"></SectionTitle>
        <p class="tl">
          基于医院数据中心清洗、标化过的高质量数据，结合知识图谱、NLP技术和深度学习算法搭建临床所需的上层应用,包括智能临床辅助、病历质控、患者
          360、电子用药记录、闭环管理等
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1je3VC7T2gK0jSZFkXXcIQFXa-740-606.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1DqMQC8v0gK0jSZKbXXbK2FXa-734-40.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1LZZPC.z1gK0jSZLeXXb9kVXa-728-714.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>

      <div class="bq-solution-item" :slot="tabs[3].slot">
        <SectionTitle :title="tabs[3].title"></SectionTitle>
        <p class="tl">
          将不同来源的数据进行关联，以数据处理、人工智能、数理统计、可视化技术为基础，形成数据挖掘分析能力，建立医院管理以及医疗业务的决策管理
          辅助支持系统。对数据进行分析，提取有价值的潜在知识，对管理决策和医疗服务提供支持，从而实现管理维度的多元化、管理粒度的精细化、医疗服
          务的智慧化，实现医疗成本、医疗质量的双控制，提供的更优质服务。
        </p>
        <div>
          <img
            class="mr124"
            src="https://img.alicdn.com/tfs/TB1YYELC9f2gK0jSZFPXXXsopXa-356-338.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            class="ml124"
            src="https://img.alicdn.com/tfs/TB1pZUMC7Y2gK0jSZFgXXc5OFXa-476-200.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1GMUTC8r0gK0jSZFnXXbRRXXa-306-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            class="mr80 ml80"
            src="https://img.alicdn.com/tfs/TB1vGMPC7T2gK0jSZFkXXcIQFXa-308-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            src="https://img.alicdn.com/tfs/TB1wrELC9f2gK0jSZFPXXXsopXa-306-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB1DgkJC4D1gK0jSZFsXXbldVXa-306-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            class="mr80 ml80"
            src="https://img.alicdn.com/tfs/TB1SyAOC4D1gK0jSZFyXXciOVXa-308-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
          <img
            src="https://img.alicdn.com/tfs/TB1OQZIC2b2gK0jSZK9XXaEgFXa-306-198.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
        <SectionTitle :title="'可视化驾驶舱'"></SectionTitle>
        <p class="tl">
          多主题、多形式、定制化展现各类管理数据。提供数据决策分析能力，给管理数据赋能。
        </p>
        <div>
          <img
            src="https://img.alicdn.com/tfs/TB11Q7JC.H1gK0jSZSyXXXtlpXa-892-848.png"
            alt="您的浏览器版本过低导致图片无法显示，请升级浏览器或更换为chrome"
          />
        </div>
      </div>
    </BqTab>
  </div>
</template>
<script>
import BqTab from '@/components/website_v3/Tab';
import SectionTitle from '@/components/website_v3/SectionTitle';

export default {
  name: 'zhyy',

  data() {
    return {
      animateTitle: [],
      titlebg:
        'https://img.alicdn.com/tfs/TB1y5YLFHH1gK0jSZFwXXc7aXXa-265-47.png',
      cover:
        'https://img.alicdn.com/tfs/TB1Du5sE.T1gK0jSZFhXXaAtVXa-1920-380.png',
      activeIndex: parseInt(this.$route.query.tab || '0'),
      tabs: [
        {
          title: '标准化数据中心',
          slot: 'datacenter',
        },
        {
          title: '智慧服务',
          slot: 'wise',
        },
        {
          title: '智慧临床',
          slot: 'clinical',
        },
        {
          title: '智慧管理',
          slot: 'manage',
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.animateTitle = ['animate-title'];
    }, 10);
  },
  components: {
    BqTab,
    SectionTitle,
  },
  methods: {
    handleClick() {},
  },
};
</script>

<style lang="less" scoped>
@import '../../../../assets/styles/fn.less';

.bq-solutions-zhyy {
  .tl {
    text-align: left !important;
  }

  .ml35 {
    margin-left: 35px;
  }

  .mr35 {
    margin-right: 35px;
  }

  .mr15 {
    margin-right: 15px;
  }

  .ml15 {
    margin-left: 15px;
  }

  .mr80 {
    margin-right: 80px;
  }

  .ml80 {
    margin-left: 80px;
  }

  .ml124 {
    margin-left: 124px;
  }

  .mr124 {
    margin-right: 124px;
  }

  .w1200 {
    width: 1200px;
    margin: 0 auto;
  }

  .bq-solutions-banner {
    position: relative;
    width: 100%;
    height: 380px;
    overflow: hidden;
    color: #fff;

    .bq-banner-cover {
      width: 100%;
      height: 100%;
      .bgNoImg();
      position: relative;

      .bq-solutions-title-wrap {
        margin: 0 auto;
        position: absolute;
        top: 130px;
        // right: 312px;
        right: 40%;
        transform: translateX(50%);
        &.animate-title {
          .bq-solutions-title {
            animation: bounce 1s linear;

            @keyframes bounce {
              0% {
                opacity: 0;
                transform: translate3d(0, 500%, 0);
              }

              60% {
                transform: translate3d(0, -30px, 0);
              }

              80% {
                transform: translate3d(0, -10px, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }

          .bq-solutions-subtitle {
            transform: translate3d(0, 0, 0);
            // opacity: 1;
            animation: leftslide 1s ease;

            @keyframes leftslide {
              0% {
                opacity: 0;
                transform: translate3d(500%, 0, 0);
              }

              100% {
                opacity: 1;
                transform: translate3d(0, 0, 0);
              }
            }
          }
        }
      }

      .bq-solutions-title {
        width: 316px;
        height: 56px;
        margin-bottom: 30px;
        background-repeat: no-repeat;
      }

      .bq-solutions-subtitle {
        width: 580px;
        margin: 0 auto;
        margin-bottom: 20px;
        text-align: center;
        font-size: 18px;

        &.lt10 {
          letter-spacing: 10px;
        }
      }
    }
  }

  .bq-solution-item {
    text-align: center;
    p {
      width: 1200px;
      margin: 0 auto;
      text-align: center;
      color: #333;
      font-size: 18px;
      margin-bottom: 60px;
    }

    & > div {
      margin-bottom: 60px;
    }

    .bq-solution-tag {
      margin: 0 auto;
      width: 363px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      font-size: 18px;
      background: rgba(32, 93, 171, 1);
      border-radius: 6px;
      cursor: default;
    }

    .bq-item-title {
      margin-top: 60px;
      margin-bottom: 0;
      color: #205dab;
      font-size: 24px;
    }

    .bq-imgbox-wrap {
      width: 1200px;
      margin: 0 auto;
      margin-bottom: 60px;
      display: flex;
      .bq-imgtext-box {
        position: relative;
        .bq-img-text {
          position: absolute;
          bottom: 88px;
          left: 40px;
          right: 40px;
          text-align: left;
          font-size: 16px;
          color: #333;
        }
      }
    }
  }
}
</style>
